import classNames from "classnames";
import React from "react";
import { UncontrolledPopover } from "tsi-common-react/src/common/Popover";

interface IProps {
    id: string;
    labelText: string;
    onAfterClose?: () => void;
    onAfterOpen?: () => void;
    children?: React.ReactNode;
}

interface IState {}

// TODO(ssr, LOW 3 out of 10): Migrate this component from class-style to functional-style. Rated LOE as 3/10 due to UncontrolledPopover integration with refs, public method exposure, and simple passthrough rendering.
export class LocatorFilterPopover extends React.Component<IProps, IState> {
    private readonly popperElem = React.createRef<UncontrolledPopover>();

    public readonly onRequestClose = () => {
        if (this.popperElem.current) {
            this.popperElem.current.requestClose();
        }
    };

    render() {
        const labelClasses = classNames({
            filters__filter: true,
            [`filters__filter--${this.props.id}`]: true,
        });
        const modalClasses = classNames({
            filters__dropdown: true,
            [`filters__dropdown--${this.props.id}`]: true,
        });

        return (
            <UncontrolledPopover
                ref={this.popperElem}
                triggerContent={this.props.labelText}
                triggerBtnProps={{
                    className: labelClasses,
                }}
                popperOptions={{
                    placement: "bottom",
                }}
                modalProps={{
                    contentLabel: this.props.labelText,
                    style: {
                        overlay: {
                            backgroundColor: "transparent",
                        },
                    },
                }}
                onAfterOpen={this.props.onAfterOpen}
                onAfterClose={this.props.onAfterClose}
            >
                <div className={modalClasses}>{this.props.children}</div>
            </UncontrolledPopover>
        );
    }
}
